import { createFileRoute } from "@tanstack/react-router";
import { ArchivePage } from "@/components/products/ArchivePage";
import { archiveSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/products/archive")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => archiveSeo(loaderData?.href ?? "/products/archive"),
  component: ArchivePage,
});
